module.exports = __webpack_public_path__ + "img/sedan.021d5b82.png";